import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import Rectangle from "../../../../source/js/shared/models/Geometry/Rectangle";
import { ShapeCategory } from '@/types/shapeCategories';
import AbstractShape, { Dimensions } from '../Shapes/AbstractShape';
import { ValidatorInterface } from '../Validators/ValidatorInterface';
import { OrValidator } from '../Validators/OrValidator';

export default class BarrelConfiguration implements ShapeConfigurationInterface {
	public hasNewValidators = true;

	get_dimension_keys(): string[] {
		return [
			'width',
			'height',
			'side_height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		const shortestSide = maximum_rectangle.get_shortest_side();
		return {
			width: maximum_rectangle.get_longest_side(),
			height: shortestSide,
			side_height: shortestSide,
		};
	}

	get_maximum_variable_dimensions( dimensions: Dimensions ): Record<string, Length> {
		const maxSideHeight = dimensions.height - 1;
		return {
			side_height: Length.from_cm(maxSideHeight),
		};
	}

	get_minimum_dimensions( minimum: number, dimensions: Dimensions ): Record<string, Length>|null {
		return {
			width: Length.from_cm(minimum),
			height: Length.from_cm(+dimensions.side_height + 1),
			side_height: Length.from_cm(minimum),
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			side_height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_new_validators( instance: AbstractShape, minimum: number, maximums: Record<string, Length>, dimensions: Dimensions ): ValidatorInterface[] {
		const maxSideHeight = dimensions.height - 1;
		const minHeight = dimensions.side_height + 1;

		return [
			new OrValidator([
				new MaximumValue( {
					field: 'barrel-side_height',
					dimension: 'side_height',
					instance,
					maximums: {
						side_height: Length.from_cm(maxSideHeight),
						height: maximums.height
					},
				} ),
				new MinimumValue( {
					field: 'barrel-height',
					dimension: 'height',
					instance,
					minimums: {
						height: Length.from_cm(minHeight),
					},
				} ),
			]),
			new MaximumDecimalPoints( {
				field: 'barrel-width',
				dimension: 'width',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumValue( {
				field: 'barrel-width',
				dimension: 'width',
				instance,
				maximums,
			} ),
			new MinimumValue( {
				field: 'barrel-width',
				dimension: 'width',
				minimum,
				instance,
			} ),
			new MaximumDecimalPoints( {
				field: 'barrel-height',
				dimension: 'height',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumValue( {
				field: 'barrel-height',
				dimension: 'height',
				instance,
				maximums,
			} ),
			new MinimumValue( {
				field: 'barrel-height',
				dimension: 'height',
				minimum,
				instance,
			} ),
			new MaximumDecimalPoints( {
				field: 'barrel-side_height',
				dimension: 'side_height',
				decimalPoints: 1,
				instance,
			} ),
			new MinimumValue( {
				field: 'barrel-side_height',
				dimension: 'side_height',
				minimum,
				instance,
			} ),
			new MaximumValue( {
				field: 'barrel-side_height',
				dimension: 'side_height',
				instance,
				maximums,
			} ),
		];
	}

	get_cutout_validators( instance: AbstractShape, dimensions: Dimensions ): ValidatorInterface[] {
		const maxSideHeight = dimensions.height - 1;
		const minHeight = dimensions.side_height + 1;

		return [
			new OrValidator([
				new MaximumValue( {
					field: 'barrel-side_height',
					dimension: 'side_height',
					instance,
					maximums: {
						side_height: Length.from_cm(maxSideHeight),
					},
				} ),
				new MinimumValue( {
					field: 'barrel-height',
					dimension: 'height',
					instance,
					minimums: {
						height: Length.from_cm(minHeight),
					},
				} ),
			]),
		];
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
